import React from "react";
import "./FeedEmptyState.scss";

const SKELETON_COUNT = 3;
const LEARN_HREF = "https://thebuyerlistingservice.com/guides";

const BroadcastGlyph = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <circle cx="12" cy="12" r="2" fill="currentColor" />
    <path
      d="M8.6 8.6a5 5 0 0 0 0 6.8M15.4 15.4a5 5 0 0 0 0-6.8M6 6a9 9 0 0 0 0 12M18 18a9 9 0 0 0 0-12"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
  </svg>
);

const PeopleGlyph = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <circle cx="9" cy="8" r="3.1" stroke="currentColor" strokeWidth="1.6" />
    <path
      d="M3.5 19a5.5 5.5 0 0 1 11 0M16 5.3a3 3 0 0 1 0 5.4M16.5 19a5.5 5.5 0 0 0-2.3-4.5"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
  </svg>
);

const CheckGlyph = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M4 13l4 4L20 7"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const FeedEmptyState = ({ onCta }) => (
  <div className="feed-empty-state">
    <div className="fes__skeleton" aria-hidden="true">
      {Array.from({ length: SKELETON_COUNT }).map((_, i) => (
        <div className="fes__sk-card" key={i}>
          <div className="fes__sk-img">
            <span className="fes__sk-badge" />
          </div>
          <div className="fes__sk-body">
            <span className="fes__sk-line fes__sk-line--w35" />
            <span className="fes__sk-line fes__sk-line--w90" />
            <span className="fes__sk-line fes__sk-line--w70" />
            <span className="fes__sk-pill" />
          </div>
          <div className="fes__sk-actions">
            <span className="fes__sk-action" />
            <span className="fes__sk-action" />
          </div>
        </div>
      ))}
    </div>

    <div className="fes__card">
      <span className="fes__eyebrow">
        <span className="fes__live-dot" /> Live demand feed
      </span>
      <h3 className="fes__title">You're early, and that's the edge.</h3>
      <p className="fes__subtitle">
        This is where real&#8209;time buyer demand across your market shows up.
        <br />
        Publish the first Buyer Want&#8209;Listing and broadcast real&#8209;time demand to
        <br />
        your MLS/association network.
      </p>

      <ol className="fes__steps">
        <li className="fes__step">
          <span className="fes__step-ic">
            <BroadcastGlyph />
          </span>
          <span className="fes__step-lb">Post a Want&#8209;Listing</span>
          <span className="fes__step-tx">Describe the home, not the person</span>
        </li>
        <span className="fes__step-conn" aria-hidden="true" />
        <li className="fes__step">
          <span className="fes__step-ic">
            <PeopleGlyph />
          </span>
          <span className="fes__step-lb">Reaches every agent</span>
          <span className="fes__step-tx">Broadcast across your network</span>
        </li>
        <span className="fes__step-conn" aria-hidden="true" />
        <li className="fes__step">
          <span className="fes__step-ic">
            <CheckGlyph />
          </span>
          <span className="fes__step-lb">Matches roll in</span>
          <span className="fes__step-tx">
            Real listings,
            <br />
            in real time
          </span>
        </li>
      </ol>

      <button
        type="button"
        className="btn btn-primary fes__cta"
        onClick={onCta}
      >
        Post a Want-Listing
      </button>

      <a
        className="fes__learn"
        href={LEARN_HREF}
        target="_blank"
        rel="noopener noreferrer"
      >
        See how the feed works &rarr;
      </a>

      <p className="fes__foot">
        As agents post buyer demand,{" "}
        <strong>it lands here in real time.</strong>
      </p>
    </div>
  </div>
);

export default FeedEmptyState;
